export default __webpack_public_path__ + "static/media/Monday.5af9a2cf.svg";